<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" *ngIf="!esDetalle">
    <div class="grid form-group">
      <!-- ESTADO -->
      <div class="col-12">
        <div class="div-form">
          <label>* {{ "CANALES.LBL_ESTADO" | translate }}</label>
          <p-multiSelect
            id="estados"
            name="estados"
            [options]="listaEstados"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}"
            formControlName="idsEstados"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsEstados.invalid"
          >
            {{ "CANALES.LBL_ESTADO" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- BOTON AGREGAR -->
    <div class="grid text-center" *ngIf="!guardando">
      <div class="form-group col-12">
        <button
          icon="fa fa-plus"
          label="{{ 'BTN_AGREGAR' | translate }}"
          type="button"
          (click)="onSubmit()"
          pButton
        ></button>
      </div>

      <div class="grid" *ngIf="guardando">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
          <span>{{ "LBL_PROCESANDO" | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <!-- BUSCADOR -->
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6"></div>
    <div class="col-12 md:col-6 lg:col-6">
      <input
        #gb
        type="text"
        pInputText
        size="40"
        placeholder="{{ 'LBL_BUSCAR' | translate }}"
        (input)="dt.filterGlobal($event.target.value, 'contains')"
      />
    </div>
  </div>

  <!-- LISTADO Restricciones Perfil por Vinculación -->
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        #dt
        [value]="lisCanalesRestriccionesGestionXEstados"
        selectionMode="single"
        dataKey="idPorcentajesLaboresCulturalesInsumos"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
        [loading]="guardando"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.codigoEstado }}</td>
            <td>{{ row.estado }}</td>
            <td class="text-center">
              <p-checkbox
                binary="true"
                id="indicadorEstado"
                name="indicadorEstado"
                [(ngModel)]="row.indicadorHabilitado"
                (onChange)="
                  habilitarInhabilitar(row)
                "
                [disabled]="esDetalle"
              ></p-checkbox>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
